import { useRoutes } from "react-router-dom";
import {
  authRoutes,
  adminRoutes,
  profRoutes,
  etudiantRoutes,
} from "./Routes/routes";
import { toast, ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db, auth } from "./Firebase";
import { CONNEXION_NAVIGATION, DASHBOARD_ADMIN_NAVIGATION, DASHBOARD_ETUDIANT_NAVIGATION, DASHBOARD_PROF_NAVIGATION } from "./Routes/NAVIGATION_PATH";
import { useNavigate } from "react-router-dom";

function AdminRoutes({ useRoutes, routes }) {
  const routeResult = useRoutes(routes);
  return routeResult;
}
function ProfRoutes({ useRoutes, routes }) {
  const routeResult = useRoutes(routes);
  return routeResult;
}
function EtudiantRoutes({ useRoutes, routes }) {
  const routeResult = useRoutes(routes);
  return routeResult;
}
function AuthRoutes({ useRoutes, routes }) {
  const routeResult = useRoutes(routes);
  return routeResult;
}

function App() {
  //state
  // const [user_id, setUserId] = useState(null)
  const navigate = useNavigate();
  const [user_type, setUserType] = useState(null);
  // const [user_id, setUserId] = useState(null);
  //console.log('le uid',userId);
  //changement d'état
  // useEffect(() => {
  //   const user_id = sessionStorage.getItem("user_id") || null;
  //   // setUserId(userId);
  //   console.log(user_id)
  //   if (user_id === null) {
  //     setUserType(null);
  //   } else {
  //     onSnapshot(doc(db, "users", user_id), (doc) => {
  //       const user = doc.data().user_type;
  //       //setUserType(user)
  //       setUserType(user);
  //     });
  //   }
  // }, []);
  //console.log(user_type);

  useEffect(() => {
    auth.onAuthStateChanged(user => {
      if (user) {
        const user_id = user.uid;
        sessionStorage.setItem("user_id", user_id)
        //setUserId(userId);
        
        onSnapshot(doc(db, "users", user_id),
          (doc) => {
            const userType = doc.data().user_type;
            setUserType(userType);
            handleRedirect(user_type);
            toast.success("Connexion reussie !");
          }
        )
      } else {
        navigate(authRoutes)
      }
    })
  }, [])


  const handleRedirect = (type) => {
    if (type === "admin") {
      navigate(DASHBOARD_ADMIN_NAVIGATION);
    } else if (type === "prof") {
      navigate(DASHBOARD_PROF_NAVIGATION);
    } else if (type === "etudiant") {
      navigate(DASHBOARD_ETUDIANT_NAVIGATION);
    }
  };

  return (
    <div>
      {user_type === "admin" && (
        <AdminRoutes useRoutes={useRoutes} routes={adminRoutes} />
      )}
      {user_type === "prof" && (
        <ProfRoutes useRoutes={useRoutes} routes={profRoutes} />
      )}
      {user_type === "etudiant" && (
        <EtudiantRoutes useRoutes={useRoutes} routes={etudiantRoutes} />
      )}
      {user_type === null && (
        <AuthRoutes useRoutes={useRoutes} routes={authRoutes} />
      )}
      <ToastContainer />
    </div>
  );
}



export default App;
